import { useTranslation } from '@testsigma/atoms';
import sync_started from '@images/sync_stated.svg';

const StandardObjectsSyncedScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center h-full'>
      <div className='leading-8 font-semibold text-secondary-1000 text-2xl'>
        {t('header.standard_objects_synced')}
      </div>

      <div className='mt-6 mb-8'>
        <img
          src={sync_started}
          className='empty-illustration'
          alt='Tick Illustration'
        />
      </div>

      <div
        className='flex mb-10 text-center text-sm text-secondary-text'
        dangerouslySetInnerHTML={{
          __html: t('message.standard_objects_ready'),
        }}
      />
    </div>
  );
};

export { StandardObjectsSyncedScreen };
